import React, { useCallback, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '../components/Header/Navbar';
import Footer from '../components/Footer';
import PolicyContainer from '../components/Policy/PolicyContainer';
import { policyService } from '../api';
import { normalizePolicyRouteSlug } from '../utils/policyRouteSlug';

const PolicyPage: React.FC = () => {
  const location = useLocation();
  const routeSlug = useMemo(
    () => normalizePolicyRouteSlug(location.pathname.replace(/^\//, '')),
    [location.pathname]
  );

  const fetchPolicy = useCallback(async () => {
    if (!routeSlug) return null;
    const result = await policyService.getByRouteSlug(routeSlug);
    return result.isSuccess && result.data ? result.data : null;
  }, [routeSlug]);

  if (!routeSlug) {
    return (
      <div className="sb-page-bg min-vh-100 d-flex flex-column">
        <Navbar />
        <main className="container py-5 flex-grow-1 text-center">
          <h1 className="h4 mb-3">Sayfa bulunamadı</h1>
          <Link className="btn btn-primary" to="/">Ana Sayfaya Dön</Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="sb-page-bg min-vh-100 d-flex flex-column">
      <Navbar />
      <main className="container py-4 flex-grow-1">
        <PolicyContainer fetchPolicy={fetchPolicy} fallbackTitle="Sözleşme" />
      </main>
      <Footer />
    </div>
  );
};

export default PolicyPage;
